import SecondLevelItem from './SecondLevelItem.jsx';

export default function SecondLevelItems({
    secondLevelNavigationItems,
    currentHoveredItemId,
    setCurrentHoveredItemId,
    thirdLevelEmpty,
}) {
    return (
        <div className="navigation__level-column -level:second" key="secon-level-items">
            {secondLevelNavigationItems
                .filter((item) => !item.overviewItem)
                .map((item, index) => (
                    <SecondLevelItem
                        key={index}
                        navigationItem={item}
                        setCurrentHoveredItemId={setCurrentHoveredItemId}
                        currentHoveredItemId={currentHoveredItemId}
                        thirdLevelEmpty={thirdLevelEmpty}
                    />
                ))}
        </div>
    );
}
